import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";


gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);
window.gsap = gsap
